<bz-form-field [label]="(placeholder() || 'Account') | translate"
               [required]="isRequired()"
               [error]="submitted() && isRequired() && !selectedId() ? ('This field is required' | translate) : ''">
  <bz-input appBringozIdGenerator="threepl-supply-account-select-input"
            size="sm"
            [readonly]="true"
            [disabled]="isDisabled()"
            [invalid]="submitted() && isRequired() && !selectedId()"
            [value]="selectedText()"
            (click)="onOpen($event)">
  </bz-input>
</bz-form-field>
